import { Translate } from './report-preview.types';

const translate = (t: Translate, key: string, fallback: string) => {
  const value = t(key);
  return value && value !== key ? value : fallback;
};

export const applyStaticTranslations = (doc: Document, t: Translate) => {
  doc.querySelectorAll<HTMLElement>('[data-i18n]').forEach(el => {
    const key = el.dataset.i18n;
    if (!key) return;
    el.textContent = translate(t, key, el.textContent ?? '');
  });

  doc.querySelectorAll<HTMLElement>('[data-i18n-html]').forEach(el => {
    const key = el.dataset.i18nHtml;
    if (!key) return;
    el.innerHTML = translate(t, key, el.innerHTML);
  });
};
